import { useFormik } from 'formik'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { editAdd, getAdd } from '../../actions/advertisingActions'
import { editJob, getJob } from '../../actions/jobsAxctions'
import CreateAdvertisingView from '../../containers/Advertising/CreateAdvertising/CreateAdvertising'
const EditAdvertising = ({ match,history }) => {
    const dispatch = useDispatch()
    const {add} = useSelector(state=>state.advertinsingReducers)
    useEffect(() => {

        dispatch(getAdd(match.params.idAdd))
        return () => {
            
        }
    }, [match.params.idAdd])

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            url: add?.url || "",
            advertisingType: add?.advertisingType || "",

        },
        onSubmit: (values) => {
            const formData = new FormData()
            formData.append("url",values.url)
            formData.append("advertisingType",values.advertisingType)

            if(values.image){
                formData.append("image",values.image)
            }
           
            
  
  
            dispatch(editAdd(formData,history))
        }


    })
    return (
        <CreateAdvertisingView formik={formik} add={add} isEdit={true} />
    )
}

export default EditAdvertising